import React from "react";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { FilterViewOurNode } from "./filter-view-our-node/filter-view-our-node";
import { useFilterViewOurNodeInitialHook } from "./filter-view-our-node/use-filter-view-our-node-initial-hook";

export const TreeViewForFilteredDataNewStructure = () => {
  const nodeManager = getNodeManager();

  return (
    <>
      <FilterViewOurNode
        useHook={useFilterViewOurNodeInitialHook}
        updateCheckboxFunc={
          nodeManager.updateInitialListAndFilteredInitialListWithSelectedNode
        }
        type="initial"
        activateDragAndDrop={true}
      />
    </>
  );
};
